<template>
  <div data-v-abca6e38="" data-v-2ac6a5fc="" class="assets-wrap s11ss">
    <div class="container">
      <!-- 头部信息区域 -->
      <div class="header">
        <div class="header-info">
          <div class="count-item">
            <div class="count-label">剩余领取次数</div>
            <div class="count-value">{{ userredpacket.sendnums || 0 }}</div>
          </div>
          <div class="count-item">
            <div class="count-label">已领取次数</div>
            <div class="count-value">{{ userredpacket.acquirednum || 0 }}</div>
          </div>
        </div>
        <a @click="$parent.goNav('/hongbao')" data-v-abca6e38="" class="btn-grab">抢红包</a>
      </div>
      
      <!-- 红包记录卡片 -->
      <div class="card">
        <div class="card-header">
          <span>红包记录</span>
          <span>总计 {{ redpacketShowData.total || 0 }} 条</span>
        </div>
        <div class="card-body">
          <div data-v-73a82902="" data-v-3acb7497="" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="record-list">
            <!-- 列表项 -->
            <div data-v-73a82902="" class="record-item" v-for="(item, index) in redpacketList" :key="index">
              <div data-v-73a82902="" class="record-info">
                <p data-v-73a82902="" class="record-title">
                  充值金额：{{ item.money }} 元
                  <span class="status-badge status-success">已完成</span>
                </p>
                <p class="record-detail">充值时间： {{ item.created_at }}</p>
              </div>
              <div class="record-amount">
                <div class="amount-main">+{{ item.redpacketmoney }} 元</div>
                <div class="amount-sub">红包金额</div>
              </div>
            </div>

            <!-- 空状态 -->
            <div data-v-abca6e38="" class="empty-state" v-if="redpacketList.length == 0">
              <div class="empty-icon">📭</div>
              <p>暂无记录</p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 分页组件 -->
      <div class="pagination" v-if="redpacketShowData.total">
        <el-pagination 
          @current-change="getredpacket" 
          :current-page.sync="page" 
          :page-size="10" 
          layout="prev, pager, next" 
          :total="redpacketShowData.total">
        </el-pagination>
      </div>
      
      <div class="footer"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'welfare',
  data() {
    return {
      redpacketList: [],
      page: 1,
      redpacketShowData: {},
      userredpacket: {},
    };
  },
  created() {
    let that = this;
    that.getredpacket();
    that.getuserredpacket();
  },
  methods: {
    getwelfare() {
      let that = this;
      if (that.userredpacket.sendnums < 1) {
        that.$parent.showTost(0, '您的剩余次数不足！');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.getredpacket();
          that.getuserredpacket();
        })
        .catch(() => {
          that.$parent.showTost(0, '服务器异常，请稍后再试');
          that.$parent.hideLoading();
        });
    },
    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.get('/api/userredpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    getredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.post('/api/redpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.redpacketList = res.data.data;
          that.redpacketShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
    window.addEventListener('scroll', this.Scroll, true);
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
    window.removeEventListener('scroll', this.Scroll, true);
  },
};
</script>

<style lang="scss" scoped>
html, body {
  background: #f5f7fa !important;
  margin: 0;
  padding: 0;
}


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.assets-wrap {
  background-color: #f5f7fa !important;
  min-height: 100vh; 
  color: #333;
  padding: 20px;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

// 头部样式
.header {
  background: linear-gradient(135deg, #ff6b6b, #ff8e53);
  color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-info {
  display: flex;
  gap: 30px;
}

.count-item {
  text-align: center;
}

.count-label {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 5px;
}

.count-value {
  font-size: 24px;
  font-weight: bold;
}

.btn-grab {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
}

.btn-grab:hover {
  background: rgba(255, 255, 255, 0.3);
}

// 卡片样式
.card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  overflow: hidden;
}

.card-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  color: #555;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-body {
  padding: 20px;
}

// 记录列表样式
.record-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.record-item {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border-radius: 8px;
  background: #f9fafc;
  transition: all 0.3s;
}

.record-item:hover {
  background: #f0f5ff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.record-info {
  flex: 1;
}

.record-amount {
  text-align: right;
}

.amount-main {
  font-size: 18px;
  font-weight: bold;
  color: #ff6b6b;
}

.amount-sub {
  font-size: 14px;
  color: #999;
  margin-top: 5px;
}

.record-title {
  font-weight: bold;
  margin-bottom: 8px;
  color: #444;
}

.record-detail {
  color: #666;
  font-size: 14px;
}

// 空状态样式
.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #999;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 15px;
  color: #ddd;
}

/* 分页卡片样式 */
.pagination {
  display: inline-block;
  padding: 10px 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: 20px 0;
}

/* 分页按钮样式 */
.pagination >>> .el-pager li {
  background: #f9fafc;
  color: #333;
  border-radius: 6px;
  margin: 0 3px;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  transition: all 0.3s;
}

.pagination >>> .el-pager li:hover {
  background: #f0f5ff;
  color: #ff6b6b;
  transform: translateY(-1px);
}

.pagination >>> .el-pager li.active {
  background: #ff6b6b;
  color: white;
  font-weight: bold;
}

.pagination >>> .el-pager li.disabled {
  background: #eee;
  color: #aaa;
  cursor: not-allowed;
}


.footer {
  height: 80px;
  background: #f5f7fa;
}
// 状态标签样式
.status-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 8px;
}

.status-success {
  background: #e6f7e6;
  color: #27ae60;
}

.status-pending {
  background: #fef5e6;
  color: #f39c12;
}

// 覆盖原有样式
.assetDetails .content .list .c[data-v-3acb7497],
.assets .content .list .c[data-v-3acb7497],
.assetDetails .content .list .c[data-v-73a82902],
.assets .content .list .c[data-v-73a82902] {
  background: transparent;
  border: none;
  padding: 0;
}

.assetDetails .content .list .c .flex-group[data-v-73a82902],
.assets .content .list .c .flex-group[data-v-73a82902] {
  height: auto;
  border-bottom: none;
  padding: 0;
}

.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902],
.assetDetails .content .list .c .flex-group .item p.txt-bold[data-v-73a82902],
.assets .content .list .c .flex-group .item p.txt-bold[data-v-73a82902] {
  color: inherit;
}
</style>
    


// WEBPACK FOOTER //
// src/components/main/welfare.vue